import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, BookOpenIcon, CalendarIcon, FolderIcon, ScrollTextIcon, SettingsIcon, HelpCircleIcon, UsersIcon, BarChartIcon, TrophyIcon, GraduationCapIcon, Users2Icon, ChevronLeftIcon, ChevronRightIcon, MinusIcon } from 'lucide-react';
interface SidebarProps {
  activePage?: 'formazione' | 'community' | 'alga';
}
const Sidebar: React.FC<SidebarProps> = ({
  activePage = 'formazione'
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isCollapsed, setIsCollapsed] = useState(false);
  return <div className={`bg-green-600 h-full flex flex-col overflow-y-auto transition-all duration-300 relative ${isCollapsed ? 'w-20' : 'w-full md:w-64'}`} style={{
    backgroundImage: `url('https://cdn.magicpatterns.com/uploads/wsCbUWp4TF3ni7DwEfb9qP/hand-drawn-turtle-shell-pattern_23-2150598661.jpg')`,
    backgroundSize: '400px',
    backgroundPosition: 'center',
    backgroundRepeat: 'repeat'
  }} data-id="element-1918">
      <div className="absolute inset-0 bg-green-600 opacity-90" data-id="element-1919"></div>

      {/* Logo Section */}
      <div className="p-6 flex items-center gap-4 relative z-10" data-id="element-1920">
        <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="Greenback Logo" className="h-8 object-contain brightness-0 invert flex-shrink-0" data-id="element-1921" />
        {!isCollapsed && <div className="flex flex-col items-start" data-id="element-1922">
            <h1 className="text-xl font-normal text-white leading-tight" data-id="element-1923">
              Greenback
            </h1>
            <h3 className="text-sm font-normal text-white/80 leading-tight" data-id="element-1924">
              Social Learning
            </h3>
          </div>}
      </div>

      {/* Divider */}
      <div className="py-3 relative z-10 flex items-center justify-center" data-id="element-1925">
        {isCollapsed ? <MinusIcon size={16} className="text-white/40" strokeWidth={1.5} data-id="element-1926" /> : <div className="w-full h-px bg-white/20" data-id="element-1927"></div>}
      </div>

      {/* Main navigation tabs */}
      <div className="px-4 relative z-10" data-id="element-1928">
        {isCollapsed ? <div className="flex flex-col items-center" data-id="element-1929">
            {activePage === 'formazione' && <Link to="/" className="p-2.5 rounded-full transition-all flex items-center justify-center bg-white text-green-600 shadow-sm" data-id="element-1930">
                <GraduationCapIcon size={20} strokeWidth={1.5} data-id="element-1931" />
              </Link>}
            {activePage === 'community' && <Link to="/community" className="p-2.5 rounded-full transition-all flex items-center justify-center bg-white text-green-600 shadow-sm" data-id="element-1932">
                <Users2Icon size={20} strokeWidth={1.5} data-id="element-1933" />
              </Link>}
          </div> : <div className="flex items-center justify-between bg-white/10 backdrop-blur-sm rounded-full p-1 w-full gap-1" data-id="element-1934">
            <Link to="/" className={`py-2 px-3 rounded-full text-sm font-normal transition-all flex items-center justify-center gap-2 flex-1 ${activePage === 'formazione' ? 'bg-white text-green-600 shadow-sm' : 'text-white hover:text-white hover:bg-white/10'}`} data-id="element-1935">
              <GraduationCapIcon size={16} strokeWidth={1.5} data-id="element-1936" />
              <span data-id="element-1937">Corsi</span>
            </Link>
            <Link to="/community" className={`py-2 px-3 rounded-full text-sm font-normal transition-all flex items-center justify-center gap-2 flex-1 ${activePage === 'community' ? 'bg-white text-green-600 shadow-sm' : 'text-white hover:text-white hover:bg-white/10'}`} data-id="element-1938">
              <Users2Icon size={16} strokeWidth={1.5} data-id="element-1939" />
              <span data-id="element-1940">Community</span>
            </Link>
          </div>}
      </div>

      {/* Divider */}
      <div className="py-3 relative z-10 flex items-center justify-center" data-id="element-1941">
        {isCollapsed ? <MinusIcon size={16} className="text-white/40" strokeWidth={1.5} data-id="element-1942" /> : <div className="w-full h-px bg-white/20" data-id="element-1943"></div>}
      </div>

      {/* Main menu items */}
      <div className="px-4 flex-1 w-full relative z-10" data-id="element-1944">
        {activePage === 'formazione' ? <div className="space-y-1 w-full" data-id="element-1945">
            <Link to="/" className="block w-full" data-id="element-1946">
              <SidebarItem icon={<HomeIcon size={20} strokeWidth={1.5} data-id="element-1948" />} text="Panoramica" active={currentPath === '/' || currentPath === ''} isCollapsed={isCollapsed} data-id="element-1947" />
            </Link>
            <Link to="/courses" className="block w-full" data-id="element-1949">
              <SidebarItem icon={<BookOpenIcon size={20} strokeWidth={1.5} data-id="element-1951" />} text="I Miei Corsi" active={currentPath === '/courses' || currentPath === '/corso'} isCollapsed={isCollapsed} data-id="element-1950" />
            </Link>
            <Link to="/calendar" className="block w-full" data-id="element-1952">
              <SidebarItem icon={<CalendarIcon size={20} strokeWidth={1.5} data-id="element-1954" />} text="Calendario" active={currentPath === '/calendar'} isCollapsed={isCollapsed} data-id="element-1953" />
            </Link>
            <Link to="/materials" className="block w-full" data-id="element-1955">
              <SidebarItem icon={<FolderIcon size={20} strokeWidth={1.5} data-id="element-1957" />} text="Materiali" active={currentPath === '/materials'} isCollapsed={isCollapsed} data-id="element-1956" />
            </Link>
            <Link to="/notes" className="block w-full" data-id="element-1958">
              <SidebarItem icon={<ScrollTextIcon size={20} strokeWidth={1.5} data-id="element-1960" />} text="Note" active={currentPath === '/notes'} isCollapsed={isCollapsed} data-id="element-1959" />
            </Link>
          </div> : activePage === 'community' ? <div className="space-y-1 w-full" data-id="element-1961">
            <Link to="/community" className="block w-full" data-id="element-1962">
              <SidebarItem icon={<HomeIcon size={20} strokeWidth={1.5} data-id="element-1964" />} text="Panoramica" active={location.pathname === '/community'} isCollapsed={isCollapsed} data-id="element-1963" />
            </Link>
            <Link to="/groups" className="block w-full" data-id="element-1965">
              <SidebarItem icon={<UsersIcon size={20} strokeWidth={1.5} data-id="element-1967" />} text="Gruppi" active={location.pathname === '/groups'} isCollapsed={isCollapsed} data-id="element-1966" />
            </Link>
            <Link to="/challenges" className="block w-full" data-id="element-1968">
              <SidebarItem icon={<TrophyIcon size={20} strokeWidth={1.5} data-id="element-1970" />} text="Challenges" active={location.pathname === '/challenges'} isCollapsed={isCollapsed} data-id="element-1969" />
            </Link>
            <Link to="/coffee" className="block w-full" data-id="element-1971">
              <SidebarItem icon={<CalendarIcon size={20} strokeWidth={1.5} data-id="element-1973" />} text="Eventi" active={location.pathname === '/coffee'} isCollapsed={isCollapsed} data-id="element-1972" />
            </Link>
            <SidebarItem icon={<BarChartIcon size={20} strokeWidth={1.5} data-id="element-1975" />} text="Report & Statistiche" isCollapsed={isCollapsed} data-id="element-1974" />
          </div> : <div className="space-y-1 w-full" data-id="element-1976">
            <SidebarItem icon={<HomeIcon size={20} strokeWidth={1.5} data-id="element-1978" />} text="Chat con Greenback AI" active isCollapsed={isCollapsed} data-id="element-1977" />
          </div>}

        {/* Divider */}
        <div className="my-6 flex items-center justify-center -mx-4" data-id="element-1979">
          {isCollapsed ? <MinusIcon size={16} className="text-white/40" strokeWidth={1.5} data-id="element-1980" /> : <div className="w-full h-px bg-white/20" data-id="element-1981"></div>}
        </div>

        {/* Settings section */}
        <div className="space-y-1 w-full" data-id="element-1982">
          <SidebarItem icon={<SettingsIcon size={20} strokeWidth={1.5} data-id="element-1984" />} text="Impostazioni" isCollapsed={isCollapsed} data-id="element-1983" />
          <SidebarItem icon={<HelpCircleIcon size={20} strokeWidth={1.5} data-id="element-1986" />} text="Assistenza" isCollapsed={isCollapsed} data-id="element-1985" />
        </div>
      </div>

      {/* Collapse/Expand Button */}
      <div className="p-4 relative z-10 border-t border-white/20" data-id="element-1987">
        <button onClick={() => setIsCollapsed(!isCollapsed)} className="w-full flex items-center justify-end p-2.5 rounded-lg text-white hover:bg-white/10 transition-colors" data-id="element-1988">
          {isCollapsed ? <ChevronRightIcon size={20} strokeWidth={1.5} data-id="element-1989" /> : <ChevronLeftIcon size={20} strokeWidth={1.5} data-id="element-1990" />}
        </button>
      </div>
    </div>;
};
interface SidebarItemProps {
  icon: React.ReactNode;
  text: string;
  active?: boolean;
  isCollapsed?: boolean;
}
const SidebarItem: React.FC<SidebarItemProps> = ({
  icon,
  text,
  active = false,
  isCollapsed = false
}) => {
  return <div className={`flex items-center px-3 py-2.5 cursor-pointer transition-all w-full rounded-lg ${active ? 'bg-white/20 backdrop-blur-sm text-white shadow-sm' : 'text-white/90 hover:bg-white/10 hover:text-white'} ${isCollapsed ? 'justify-center' : ''}`} data-id="element-1991">
      <span className={isCollapsed ? '' : 'mr-3'} data-id="element-1992">{icon}</span>
      {!isCollapsed && <span className="font-normal text-sm" data-id="element-1993">{text}</span>}
    </div>;
};
export default Sidebar;